
import React, { useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import { FileText } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

// Policy details node component for the flow editor
export const PolicyDetailsNode = ({ data, isConnectable }: any) => {
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(isMobile);
  
  return (
    <div className="bg-white border rounded-md shadow-sm p-2 w-[200px]">      
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <FileText className="h-4 w-4 text-indigo-500" />
          <span className="font-medium text-sm truncate max-w-[130px]">{data.label}</span>
        </div>
        {isMobile && (
          <button 
            onClick={() => setCollapsed(!collapsed)}
            className="text-gray-500 hover:text-gray-700"
          >
            {collapsed ? '+' : '-'}
          </button>
        )}
      </div>
      
      {!collapsed && (
        <div className="mt-2 text-xs space-y-1 text-gray-600">
          <div className="flex justify-between">
            <span>Name:</span> 
            <span className="font-medium truncate max-w-[120px]">{data.policyName || 'Untitled Policy'}</span>
          </div>
          <div className="flex justify-between">
            <span>Category:</span> 
            <span className="font-medium">{data.category || 'Uncategorized'}</span>
          </div>
          <div className="flex justify-between">
            <span>Status:</span> 
            <span className={`font-medium ${data.isActive ? 'text-green-600' : 'text-gray-400'}`}>
              {data.isActive ? 'Active' : 'Inactive'}
            </span>
          </div>
        </div>
      )}
      
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className="w-2 h-2 rounded-full bg-indigo-500 border-2 border-white"
      />
    </div>
  );
};
